import { SolutionLayout } from "@/components/shikra/SolutionLayout";

const CAPABILITIES = [
  {
    title: "Solar + storage economic dispatch",
    description:
      "Generation, storage and load are dispatched against your tariff, updating our strategy every few minutes as conditions change. We charge when power is cheap or free, and discharge when it isn't, faster and more decisively than any manual operator.",
  },
  {
    title: "Time-of-use tariff optimisation",
    description:
      "Our dispatch strategies account for ToU windows, demand charges and peak surcharges specific to your state, your discom and your connection agreement. We ensure that we always optimise specifically for your use case.",
  },
  {
    title: "Dynamic load management",
    description:
      "Flexible loads are shifted or shed gracefully to stay under sanctioned demand, without touching critical processes or production schedules. The strategic deployment of such loads can offset the need for grid connection upgrades for years, without any measurable effect on productivity.",
  },
  {
    title: "Degradation-aware battery cycling",
    description:
      "Battery cycling decisions always price in the state-of-health cost of every charge and discharge, so that savings this quarter don't cost you in battery replacement charges next year.",
  },
  {
    title: "Compliance & telemetry reporting",
    description:
      "We provide you one verified stream of telemetry for audits, carbon reporting and board-level energy reviews. Site-specific insights, data analysis, and metrics are assembled for you automatically.",
  },
];

const STEPS = [
  {
    label: "Simulate",
    title: "We simulate your site",
    description:
      "Share your load profile, tariff and assets. We will model your system and come back with projected earnings on deploying our solution.",
  },
  {
    label: "Deploy",
    title: "We install at the edge",
    description:
      "Edge controllers sit beside your inverters and meters. Installation happens without downtime to operations.",
  },
  {
    label: "Optimise",
    title: "We optimise continuously",
    description:
      "Dispatch runs every few minutes, and performance is reviewed against your savings target. Our models are always evolving, and your data is used to optimise the algorithms for your site.",
  },
];

export default function ForCI() {
  return (
    <SolutionLayout
      testid="solution-page-ci"
      eyebrow="Solutions / For EPC & BESS Integrators - Behind the Meter (BTM)"
      title="Behind-the-meter optimisation for industrial energy users."
      lead="Your rooftop solar, storage, diesel generator and load already form a small microgrid; it just isn't being run like one. Shikra's control layer brings utility-scale rigor to industrial sites, dispatching your assets against your tariff in real time, turning installed capacity into maximum savings."
      capabilities={CAPABILITIES}
      steps={STEPS}
      ctaText="Get your site simulated."
    />
  );
}
